import { connect, ConnectedProps } from "react-redux";

import { AvailabilitySearchControl } from "./component";
import { IStoreState } from "../../../../reducers/types";
import {
  getTravelWalletCredit,
  getTravelWalletOffers,
} from "../../../travel-wallet/reducer";

const mapStateToProps = (state: IStoreState) => {
  return {
    walletItemCount: getTravelWalletCredit(state)
      ? getTravelWalletOffers(state).length + 1
      : getTravelWalletOffers(state).length,
  };
};

const connector = connect(mapStateToProps);

export type AvailabilitySearchControlConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedAvailabilitySearchControl = connector(
  AvailabilitySearchControl
);
